import { getStorage } from "../storage";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

// The tick-list, the reasons and the two statements all come from the server.
// The list order is the paper form's order and the statement is the wording
// that will actually be stored against the doctor's name, so neither is worth
// keeping a second copy of in the client.
export const fetchEmergencyOptions = async () => {
  const user = await getStorage();

  const queryRes = await api({
    method: "GET",
    url: `${API_URL}/bloodRequest/emergency-options`,
    headers: { Authorization: `Bearer ${user?.token}` },
  });

  return queryRes?.data?.data || queryRes?.data || {};
};

export const endorseEmergencyRequest = async (id) => {
  const user = await getStorage();

  const queryRes = await api({
    method: "POST",
    url: `${API_URL}/bloodRequest/emergency-endorse`,
    data: { id },
    headers: { Authorization: `Bearer ${user?.token}` },
  });

  return queryRes?.data?.data || queryRes?.data || {};
};

export const addEmergencyResults = async ({ id, patientBloodGroup, results }) => {
  const user = await getStorage();

  const queryRes = await api({
    method: "POST",
    url: `${API_URL}/bloodRequest/emergency-results`,
    data: { id, patientBloodGroup, results },
    headers: { Authorization: `Bearer ${user?.token}` },
  });

  return queryRes?.data?.data || queryRes?.data || {};
};

// Pulls a unit back after it tested incompatible: the shipment is cancelled
// and the unit returns to stock, ready to be replaced by a compatible one.
export const recallEmergencyUnit = async ({ id, donationNumber, code }) => {
  const user = await getStorage();

  const queryRes = await api({
    method: "POST",
    url: `${API_URL}/bloodRequest/emergency-recall`,
    data: { id, donationNumber, code },
    headers: { Authorization: `Bearer ${user?.token}` },
  });

  return queryRes?.data?.data || queryRes?.data || {};
};
